import { marketingAdministratorRoles } from "../config/roles";
import { ListDefinition } from "./listDefinition.types";

const recordRoute = "/email-preference-group";

/**
 * The email preference groups list. Every group comes back in one request, so its
 * filters narrow what is already loaded rather than asking again.
 */
export const subscriptionGroupsListDefinition: ListDefinition = {
  path: "/email-preference-groups",
  entityName: "g4c_subscriptiongroup",
  recordRoute,
  title: "Email Preference Groups",
  allowedRoles: marketingAdministratorRoles,
  data: "all-at-once",
  filters: [
    {
      name: "Name",
      label: "Name",
      kind: "text",
      searchFields: ["Name"],
      width: "wide",
    },
    {
      name: "createdon",
      label: "Created",
      kind: "date-range",
      advanced: true,
    },
    {
      name: "modifiedon",
      label: "Modified",
      kind: "date-range",
      advanced: true,
    },
  ],
  filterByStatus: true,
  allowAdd: true,
  allowStatusEdit: true,
  columns: [
    {
      key: "Name",
      label: "Name",
      width: 300,
      sortable: true,
      link: { to: recordRoute, idKey: "Id", newTab: "button" },
    },
    {
      key: "g4c_sequencenumber",
      label: "Sequence",
      width: 200,
      sortable: true,
    },
    {
      key: "createdon",
      label: "Created On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
    {
      key: "modifiedon",
      label: "Modified On",
      width: 200,
      display: "datetime",
      sortable: true,
    },
  ],
};
